/* eslint-disable no-param-reassign */
import * as types from '@/store/types';

export default {
  [types.FETCH_QUESTIONS](state, { questions }) {
    state.questions = questions.data;
  },

  [types.FETCH_TEST](state, { test }) {
    state.test = test.data;
  },
};
